/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as AdminTenantsIdRouteImport } from './routes/_admin/tenants_.$id'

const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTenantsIdRoute = AdminTenantsIdRouteImport.update({
  id: '/tenants_/$id',
  path: '/tenants/$id',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AdminIndexRoute
  '/login': typeof LoginRoute
  '/tenants/$id': typeof AdminTenantsIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AdminIndexRoute
  '/tenants/$id': typeof AdminTenantsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/_admin/': typeof AdminIndexRoute
  '/_admin/tenants_/$id': typeof AdminTenantsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/tenants/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/' | '/tenants/$id'
  id: '__root__' | '/_admin' | '/login' | '/_admin/' | '/_admin/tenants_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/tenants_/$id': {
      id: '/_admin/tenants_/$id'
      path: '/tenants/$id'
      fullPath: '/tenants/$id'
      preLoaderRoute: typeof AdminTenantsIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminTenantsIdRoute: typeof AdminTenantsIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminTenantsIdRoute: AdminTenantsIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
